import React from "react";
import { ReportZoneContextProvider } from "./ReportZoneView";
import ReportZone from "./view/ReportZone";
import Content from "../../constants/contentFile.json"

const ReportZonePage = () => {
  return (
    <ReportZoneContextProvider>
      <ReportZone textContent= {Content.employeeNameZone}/>
    </ReportZoneContextProvider>
  );
};

export default ReportZonePage;
